module.exports = __webpack_public_path__ + "img/cocopay-logo-colored.18913b9d.png";